import client01 from "./assets/img/web/clients/client-01.webp";
import client02 from "./assets/img/web/clients/client-02.webp";
import client03 from "./assets/img/web/clients/client-03.webp";
import client04 from "./assets/img/web/clients/client-04.webp";
import client05 from "./assets/img/web/clients/client-05.webp";
import client06 from "./assets/img/web/clients/client-06.webp";
import client07 from "./assets/img/web/clients/client-07.webp";
import client08 from "./assets/img/web/clients/client-08.webp";
import client09 from "./assets/img/web/clients/client-09.webp";
import client10 from "./assets/img/web/clients/client-10.webp";
import client11 from "./assets/img/web/clients/client-11.webp";
import client12 from "./assets/img/web/clients/client-12.webp";
import client13 from "./assets/img/web/clients/client-13.webp";
import client14 from "./assets/img/web/clients/client-14.webp";
import client15 from "./assets/img/web/clients/client-15.webp";
import client16 from "./assets/img/web/clients/client-16.webp";
import client17 from "./assets/img/web/clients/client-17.webp";
import client18 from "./assets/img/web/clients/client-18.webp";
import client19 from "./assets/img/web/clients/client-19.webp";
import client20 from "./assets/img/web/clients/client-20.webp";
import client21 from "./assets/img/web/clients/client-21.webp";
import client22 from "./assets/img/web/clients/client-22.webp";
import client23 from "./assets/img/web/clients/client-23.webp";
import client24 from "./assets/img/web/clients/client-24.webp";
import client25 from "./assets/img/web/clients/client-25.webp";
import client26 from "./assets/img/web/clients/client-26.webp";
import client27 from "./assets/img/web/clients/client-27.webp";
import client28 from "./assets/img/web/clients/client-28.webp";

// Names and order follow the customer logos included in the original website.
// Source-to-optimized mappings are recorded in assets/img/web/asset-manifest.json.
export const clients = [
  { id: "client-01", name: "NHK Spring (Thailand)", image: client01 },
  { id: "client-02", name: "UACJ", image: client02 },
  { id: "client-03", name: "Sumitomo Rubber Thailand", image: client03 },
  { id: "client-04", name: "Toyota", image: client04 },
  { id: "client-05", name: "BlueScope", image: client05 },
  { id: "client-06", name: "Tetra Pak", image: client06 },
  { id: "client-07", name: "NOK", image: client07 },
  { id: "client-08", name: "Yokohama", image: client08 },
  { id: "client-09", name: "Hitachi Metals", image: client09 },
  { id: "client-10", name: "Katoen Natie", image: client10 },
  { id: "client-11", name: "Ajinomoto", image: client11 },
  { id: "client-12", name: "AutoAlliance Thailand", image: client12 },
  { id: "client-13", name: "CASTEM", image: client13 },
  { id: "client-14", name: "Chevrolet", image: client14 },
  { id: "client-15", name: "Danieli", image: client15 },
  { id: "client-16", name: "EXEDY Clutch Europe Ltd.", image: client16 },
  { id: "client-17", name: "Ford", image: client17 },
  { id: "client-18", name: "GS Battery", image: client18 },
  { id: "client-19", name: "Koyama Co., Ltd.", image: client19 },
  { id: "client-20", name: "INEOS", image: client20 },
  { id: "client-21", name: "Electrolux", image: client21 },
  { id: "client-22", name: "JFE", image: client22 },
  { id: "client-23", name: "Dumex", image: client23 },
  { id: "client-24", name: "Luckytex", image: client24 },
  { id: "client-25", name: "Michelin", image: client25 },
  { id: "client-26", name: "Nippon Steel & Sumitomo Metal", image: client26 },
  { id: "client-27", name: "Praxair", image: client27 },
  { id: "client-28", name: "Tostem", image: client28 },
];

export default clients;
